<template>
  <div class="Com_4">
    <title1 type="1" title="光伏电站实时运行与环境监测" />
    <title1 type="2" title="运行数据" :right="true">
      <template v-slot:tab>
        <div class="title-3 flex justify-content align-items">
          <span
            :class="['tabItem', indexc == index ? 'active' : '']"
            v-for="(item, index) in tabList"
            :key="index"
            @click="tabClick(item, index)"
            >{{ item.name }}</span
          >
        </div>
      </template>
    </title1>
    <div
      class="box-item flex justify-content-evenly"
      style="width: 565px;"
    >
      <div class="small-box" :key="index">
		  <div class="left">
			  <img src="@/assets/images/photovoltaic/lightButton.png" alt="">
		  </div>
		  <div class="right">
			  <div class="small-top">{{ currrobj.fdl }}</div>
			  <div class="small-center">发电量（KWh）</div>
		  </div>
      </div>
		  <div class="small-box" :key="index">
		        <div class="left">
		          <img src="@/assets/images/photovoltaic/lightButton.png" alt="">
		        </div>
		        <div class="right">
		          <div class="small-top">{{ currrobj.zfzyl }}</div>
		          <div class="small-center">自用发电率</div>
		        </div>
		  </div>
    </div>
	  <div class="small-box1">
		  <div class="small-box1-cell">
			  <div class="top">碳减排(Kg)</div>
			  <div class="bottom">{{ currrobj.tjp }}</div>
		  </div>
		  <div class="small-box1-cell">
		  			  <div class="top">节约标准煤(Kg)</div>
		  			  <div class="bottom">{{ currrobj.jybzm }}</div>
		  </div>
		  <div class="small-box1-cell">
		  			  <div class="top">等效植树(棵)</div>
		  			  <div class="bottom">{{ currrobj.dxzs }}</div>
		  </div>
		  <div class="small-box1-cell">
		  			  <div class="top">二氧化硫(Kg)</div>
		  			  <div class="bottom">{{ currrobj.eyhl }}</div>
		  </div>
		  <div class="small-box1-cell">
		  			  <div class="top">减少用油(Kg)</div>
		  			  <div class="bottom">{{ currrobj.jsyy }}</div>
		  </div>
		  <div class="small-box1-cell">
		  			  <div class="top">氮氧化物(Kg)</div>
		  			  <div class="bottom">{{ currrobj.yyhw }}</div>
		  </div>
	  </div>
  </div>
</template>
  
  <script>
import title1 from "@/views/exposition/components/title3";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    MyEcharts,
    title1,
  },
  data() {
    return {
      showcdata: false,
		  currrobj:{},
		  nianobj:{},
      list: [
        {
          name: "发电量（KWh）",
          number: "126",
          typeNumber: "431",
        },
        {
          name: "自用发电率",
          number: "56%",
          typeNumber: "3123",
        },
      ],
      tabList: [
        {
          name: "日",
        },
        {
          name: "月",
        },
        {
          name: "年",
        },
      ],
	    allObj:[{},{},{}],
      indexc: 0,
	    timer: ''
    };
  },
  mounted() {
    this.initData()
  },
  destroyed() {
	  clearInterval(this.timer)
  },
  methods: {
    tabClick(item, index) {
      this.indexc = index || 0;
	    this.currrobj = this.allObj[index]
    },
    initData() {
      let params = {
        "enCode": "zngf-dz-yunxingshuju",// 接口code
        "@station_id": localStorage.getItem('guangfuStationId') ? localStorage.getItem('guangfuStationId') : "320500H001" // 接口传参
      }
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "运行数据");
          if (res) {
					  res.forEach((item, index) => {
						  if(item.rq === '日'){
							  this.allObj[0] = item;
							  this.currrobj = item;
						  }
						  else if(item.rq === '月'){
						    this.allObj[1] = item;
						  }
						  else if(item.rq === '年'){
						    this.allObj[2] = item;
						  }
					  })
					  console.log(this.allObj, "运行数据");

					  this.timer =  setInterval(()=>{
						  this.indexc ++
						  if(this.indexc >= 3) {
							  this.indexc = 0
						  }
						  this.currrobj = this.allObj[this.indexc]
					  }, 5000)
          }
        })
        .catch((err) => {
          console.log(err, "运行数据err");
        });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
@import "@/assets/scss/comm.scss";
.Com_4 {
  .title-3 {
    width: 35%;
    height: 90%;
    background: url(~@/assets/images/myComm/title-3-3.png) left bottom no-repeat;
    background-size: 100% 54px;
    float: right;
    .tabItem {
      padding: 0 2px;
      display: inline-block;
      height: 100%;
      display: flex;
      align-items: center;
      color: rgba(0, 178, 188, 1);
    }
    .active {
      color: rgba(192, 251, 248, 1);
      border-bottom: 2px solid rgba(192, 251, 248, 1);
    }
  }
  .box-item {
    width: 562px;
    height: 100%;
    padding: 10px 0 5px 0;
    .small-box {
      width: 260px;
      height: 130px;
      background: linear-gradient(
        180deg,
        #01726f 0%,
        rgba(15, 52, 68, 0.3) 100%
      );
      border-radius: 4px 4px 4px 4px;
      display: flex;
	  .left{
		  width: 90px;
		img{
			margin-top: 20px;
			margin-left: 10px;
			width: 88px;
		}
	  }
	  .right{
		  font-weight: 600;
		 .small-top {
		   width: 100%;
		   height: 78px;
		   padding-left: 20px;
		   line-height: 90px;
		   color: rgba(255, 255, 255, 0.9);
		   font-size: 32px;
		 }
		 .small-center {
		   width: 100%;
		   height: 40px;
		   line-height: 30px;
		   font-size: 18px;
		   padding-left: 20px;
		 } 
	  }
      
      .small-bottom {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        padding-left: 20px;
      }
    }
  }
  .small-box1{
  	width: 565px;
  	display: flex;
  	justify-content: space-between;
	flex-wrap: wrap;
	padding: 0 15px;
  	.small-box1-cell{
		border-radius: 4px;
		margin-top: 18px;
  		width: 170px;
  		height: 90px;
		padding: 20px;
  		background: rgba(15, 52, 68, 0.5);
		.top{
			height: 30px;
			line-height:30px;
		}
		.bottom{
			height: 30px;
			line-height:30px;
			font-size: 22px;
		}
  	}
  }
}
</style>